import { Link, useNavigate, useLocation } from "react-router-dom";
import { Nav } from "./Nav";
import { useAuthTools, usePermissions } from "../providers/authProvider";
import { useEffect, useMemo } from "react";
import { useColorMode } from "../hooks/useColorMode";
import { BUTTON_COLORS, BUTTON_TYPE } from "./Button";
import { useCart } from "../providers/cart";
import packageJson from "../../../package.json";
import {
  UNDERLINE_CLASS_LARGE,
  UNDERLINE_CLASS_LARGE_DISABLED,
} from "../utils";
import { CART_URL, USER_AUTH_URL } from "../config";

export const Header = ({ style }: { style?: "sm" | "lg" }) => {
  const { cart, resetCart } = useCart();
  const [, setColorMode] = useColorMode();
  useEffect(() => setColorMode("light"), []);
  const { logout } = useAuthTools();
  const userPermissions = usePermissions();
  const navigate = useNavigate();
  const location = useLocation();
  const loginOptions = useMemo(() => {
    const welcomBackUser = {
      text: `Hi ${userPermissions?.data?.user?.name}!`,
    };
    const version = {
      text: "V" + packageJson.version,
    };

    const loading = { text: "Loading" };
    const loginBtn = {
      text: "Log in",
      href: USER_AUTH_URL("login"),
    };
    const logoutBtn = {
      text: "Log out",
      onClick: () => {
        logout?.();
        resetCart?.();
        navigate("/");
      },
    };
    const signUpBtn = {
      text: "Sign up",
      href: USER_AUTH_URL("create"),
    };
    return (
      userPermissions?.loading
        ? [loading]
        : userPermissions?.data?.loggedIn
        ? [
            ...(userPermissions.data?.user?.name
              ? [welcomBackUser, version]
              : [version]),
            logoutBtn,
          ]
        : location.pathname === USER_AUTH_URL("login")
        ? [signUpBtn]
        : location.pathname === USER_AUTH_URL("create")
        ? [loginBtn]
        : [loginBtn, signUpBtn]
    ) as {
      text: string;
      href?: string;
      onClick?: () => void;
      className?: string;
    }[];
  }, [
    logout,
    location.pathname,
    navigate,
    userPermissions?.data,
    userPermissions?.data?.loggedIn,
    userPermissions?.data?.user?.name,
  ]);

  return (
    <div
      className="p-4 lg:p-5 pt-2 text-center

    "
    >
      <div className="flex justify-between pt-1">
        <div className="flex lg:h-[0px] items-center z-10">
          {/* <Button
            btnType="nav"
            btnColor="nav"
            onClick={() => {
              setColorMode((mode) => (mode === "light" ? "dark" : "light"));
            }}
          >
            {colorMode === "light" ? "Dark mode" : "Light mode"}
          </Button> */}
        </div>
        <div className="flex flex-wrap 3xl:h-[0px] items-center z-10">
          {loginOptions.map((loginOption) => {
            const className = `${
              loginOption.onClick || loginOption.href
                ? BUTTON_TYPE.nav + BUTTON_COLORS.nav
                : " cursor-default"
            } ${loginOption.className ?? ""}
          flex-none text-center mx-3`;
            return loginOption.href ? (
              <Link
                key={loginOption.text}
                to={loginOption.href}
                className={className}
              >
                {loginOption.text}
              </Link>
            ) : (
              <button
                key={loginOption.text}
                onClick={loginOption.onClick ? loginOption.onClick : () => {}}
                className={className}
              >
                {loginOption.text}
              </button>
            );
          })}
          {cart?.items?.length ? (
            <Link
              to={CART_URL()}
              className={`${BUTTON_TYPE.nav} ${BUTTON_COLORS.nav}  mx-3`}
            >
              Cart <sup>{cart?.items?.length}</sup>
            </Link>
          ) : null}
        </div>
      </div>
      <div className="flex justify-center">
        <Link
          id="homepage"
          to="/art"
          className={
            " pointer  " +
            (location.pathname === "/art"
              ? UNDERLINE_CLASS_LARGE_DISABLED
              : UNDERLINE_CLASS_LARGE)
          }
        >
          <h1
            className={
              "pt-4 " +
              (style === "sm" ? "text-4xl lg:text-5xl" : "text-6xl lg:text-8xl")
            }
          >
            <i>
              doridium
              {/* <span
                className={
                  style === "sm" ? "text-sm lg:text-lg" : "text-lg lg:text-3xl"
                }
              >
                .com
              </span> */}
            </i>
          </h1>

          {userPermissions?.data?.user?.admin ? (
            <strong>
              <span
                className={
                  style === "sm"
                    ? "text-lg lg:text-2xl"
                    : "text-2xl lg:text-5xl"
                }
              >
                ADMIN EDITION
              </span>
            </strong>
          ) : null}
        </Link>
      </div>
      <Nav />
    </div>
  );
};
